import styled from '@emotion/styled';
import Image from '@base/Image';
import { Spacings, mediaQuery } from '@styles/index';

const LiveIcon = 'quiz/live.svg';

const ImageWrapper = styled.div`
  position: relative;
`;

const PulsatingCirlce = styled.div`
  position: absolute;
  width: ${Spacings.SPACING_4B};
  height: ${Spacings.SPACING_4B};
  border-radius: 50%;
  background-color: var(--color-i-red);
  top: 48px;
  left: 32px;
  animation: fade 1000ms infinite;

  ${mediaQuery.uptoTablet} {
    top: 42px;
    left: 27px;
  }

  ${mediaQuery.uptoMobile} {
    top: 43px;
    left: 28px;
  }

  @keyframes fade {
    from {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @-webkit-keyframes fade {
    from {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const LiveImage = () => {
  return (
    <ImageWrapper>
      <Image height={260} width={360} src={LiveIcon} alt="live" />
      <PulsatingCirlce />
    </ImageWrapper>
  );
};

export default LiveImage;
